// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"Vvas4RGcRnEE1pwZqpDM","descriptionContent":"_wlK6FVFB2YoPuXcg52h","wrapper":"LNrTsappQPNw5Z5vmIES"};